WYATT.registerComponent(
  "wyatt-drawer",
  class WyattDrawer extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector("[data-drawer-open]");
      this.drawer = this.getDrawer();
      this.wrapper = this.drawer.querySelector("[data-drawer-wrapper]");

      document.querySelector("body").append(this.drawer);

      this.openButton.addEventListener("click", this.open.bind(this));

      this.handleClickOutside();

      this.drawer.addEventListener("close", () => {
        WYATT.toggleScrollLock("remove");
      });
    }

    disconnectedCallback() {
      this.drawer.remove();
    }

    open() {
      this.drawer.showModal();
      this.drawer.classList.add("drawer--active");
      WYATT.toggleScrollLock("add");
    }

    handleClickOutside() {
      this.drawer.addEventListener("click", () => {
        this.drawer.classList.remove("drawer--active");
        this.drawer.close();
      });
      this.wrapper.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }

    getDrawer() {
      return (
        this.querySelector("[data-drawer]") ||
        document.querySelector(this.openButton.dataset.drawerOpen)
      );
    }
  }
);
